import '../../style/index.less';
import './index.less';
// style dependencies
import '../../button/style';
import '../../menu/style';
import '../../space/style';
